/* eslint-disable jira/filename-case */
import type { State } from './State.types.tsx';

export const EMPTY_STATE: State = {
	entityLimits: undefined,
	meta: {
		loaded: false,
		loading: false,
		loadingError: undefined,
	},
};
